import {
    FaTools,
    FaBullseye,
    FaUsers,
    FaCogs,
    FaChartLine,
    FaRocket
} from "react-icons/fa";

export default function SectionWhyChooseMean3() {
    const features = [
        {
            title: "Technical First SEO Approach",
            icon: <FaTools className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Search Intent Driven Content Strategy",
            icon: <FaBullseye className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Focus on Qualified Traffic, Not Vanity Rankings",
            icon: <FaUsers className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Custom Strategies With No Templates",
            icon: <FaCogs className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Transparent Reporting and Tracking",
            icon: <FaChartLine className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Long Term Growth Focus, Not Quick Fixes",
            icon: <FaRocket className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        }
    ];

    return (
        <div className="SectionWhyChooseMean3 py-[60px] md:py-[100px] bg-white">
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Why Choose Mean3 for SEO Services
                </h2>

                <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[750px] mx-auto leading-[28px]">
                    Mean3 is a performance driven SEO agency focused on real business growth.
                </p>

                <p className="mt-0 text-[#555] text-[16px] md:text-[18px] max-w-[850px] mx-auto leading-[28px]">
                    We do not just improve rankings. We improve real business outcomes from search.
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
                {features.map((feature, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:scale-105 duration-300"
                    >
                        {/* Icon */}
                        <div className="mb-5">{feature.icon}</div>

                        {/* Title */}
                        <h3 className="text-[18px] md:text-[22px] font-semibold text-[#151515] leading-[30px]">
                            {feature.title}
                        </h3>
                    </div>
                ))}
            </div>
        </div>
    );
}